const MONTHS = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
const parse = (d) => (d ? new Date(String(d).slice(0, 10) + "T12:00:00") : null);
const ROME = "Europe/Rome";
export function todayRome(date = new Date()) {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: ROME, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(date).filter(x => x.type !== "literal").map(x => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}`;
}
const nowRome = () => { const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: ROME, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(new Date()).filter(x => x.type !== "literal").map(x => [x.type, x.value])); return new Date(`${p.year}-${p.month}-${p.day}T${p.hour === "24" ? "00" : p.hour}:${p.minute}:${p.second}`); };

export function fmtDate(d) {
  const x = parse(d); if (!x || isNaN(x)) return "";
  return `${x.getDate()} ${MONTHS[x.getMonth()]} ${x.getFullYear()}`;
}

export function fmtRange(start, end) {
  const a = parse(start), b = parse(end);
  if (!a || isNaN(a)) return "";
  if (!b || isNaN(b) || a.toDateString() === b.toDateString()) return fmtDate(start);
  if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) return `${a.getDate()}–${b.getDate()} ${MONTHS[a.getMonth()]} ${a.getFullYear()}`;
  if (a.getFullYear() === b.getFullYear()) return `${a.getDate()} ${MONTHS[a.getMonth()]} – ${b.getDate()} ${MONTHS[b.getMonth()]} ${a.getFullYear()}`;
  return `${fmtDate(start)} – ${fmtDate(end)}`;
}

export function rallyStatus(start, end) {
  const a = parse(start), b = parse(end || start), now = nowRome();
  if (!a || isNaN(a)) return { code: "TBA", label: "DATA DA DEFINIRE" };
  const dayStart = new Date(a); dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(b); dayEnd.setHours(23, 59, 59, 999);
  if (now > dayEnd) return { code: "FINISHED", label: "CONCLUSO" };
  if (now >= dayStart) return { code: "LIVE", label: "LIVE" };
  const days = Math.ceil((dayStart - now) / 86400000);
  return { code: "UPCOMING", label: days === 1 ? "DOMANI" : `TRA ${days} GIORNI`, days };
}
